<template>
  <div class="image-preview-container">
    <template v-if="id">
      <div v-if="index > -1" class="image-list">
        <image-viewer ref="imgViewer" :z-index="9999" :initial-index="index" :url-list="imgList" :onSwitch="onSwitch"/>
      </div>
    </template>
    <template v-else>
      <div class="img-preview-content">
        <!-- png、jpg、gif、jpeg -->
        <img :src="src"/>
      </div>
    </template>
  </div>
</template>

<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'image-preview',
  components: {ImageViewer},
  data () {
    return {
      src: '',
      id: '',
      imgList: [],
      index: -1,
      fileList: []
    }
  },
  methods: {
    getDownLoadUrl (path) {
      return sessionStorage.getItem('ossDownloadUrl') + path
    },
    onSwitch (index) {
      this.setTitle(index)
    },
    setTitle (index = this.index) {
      document.title = this.fileList[index].name
    }
  },
  created () {
    if (this.$route.query.id) {
      try {
        this.id = this.$route.query.id
        let src = this.$route.query.src
        if (!this.$route.query.once) {
          this.fileList = JSON.parse(sessionStorage.getItem(this.$route.query.id))
          this.imgList = this.fileList.map(m => m.url.includes('http') ? m.url : this.getDownLoadUrl(m.url))
          this.index = this.fileList.findIndex(f => f.url === src)
          this.$nextTick(() => this.setTitle())
        } else {
          // 给表格用。本来想用下面的那个，但是样式不一致。索性新增个判断
          this.imgList = [src.includes('http') ? src : this.getDownLoadUrl(src)]
          this.index = 0
          document.title = this.$route.query.name
        }
      } catch (e) {
        this.$message.error('图片预览失败，请关闭页面重新预览试试')
        throw new Error(e)
      }
    } else {
      if (this.$route.query.name) {
        document.title = this.$route.query.name
      }
      if (this.$route.query.src) {
        this.src = this.$route.query.src
      }
    }
  }
}
</script>

<style lang="scss">
  .image-preview-container {
    height: 100%;
    .img-preview-content {
      display: flex;
      height: 100%;
      background-color: black;
      img {
        max-width: 100%;
        max-height: calc(100% - 70px);
      }
    }
    .image-list {
      height: 100%;
      .el-image-viewer__wrapper {
        .el-image-viewer__close {
          display: none;
        }
        .el-image-viewer__canvas {}
      }
      & > .el-image-viewer__wrapper {
        .el-image-viewer__btn {
          &:hover {
            color: #5cb6ff;
          }
          &:active {
            color: #54abf2;
          }
          & > .el-icon-arrow-left, & > .el-icon-arrow-right {
            font-size: 23px;
          }
        }
        .el-image-viewer__actions__inner {
          & > i {
            cursor: pointer;
            font-size: 23px;
            &:hover {
              color: #5cb6ff;
            }
            &:active {
              color: #54abf2;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/image-preview.vue